module.exports = __webpack_public_path__ + "static/media/new_battery.eed9970e.svg";